<!-- Time Period Tabs -->
<!-- Two fixed groups, not one group with a loop inside it: cs-segment collects its buttons once, when
     it is created, and this toolbar is OnPush, so buttons that sit inside a control-flow block within
     the group are never collected and none of them is ever highlighted. -->
@if (periodSet === TimePeriodSet.WeekCounts) {
  <cs-segment [(selection)]="timePeriod" (selectionChange)="handleTimePeriodChange($event)">
    <cs-segment-button value="2weeks">
      {{ periodLabel('2weeks') }}
    </cs-segment-button>
    <cs-segment-button value="4weeks">
      {{ periodLabel('4weeks') }}
    </cs-segment-button>
    <cs-segment-button value="8weeks">
      {{ periodLabel('8weeks') }}
    </cs-segment-button>
    <cs-segment-button value="12weeks">
      {{ periodLabel('12weeks') }}
    </cs-segment-button>
    <cs-segment-button value="year">
      {{ periodLabel('year') }}
    </cs-segment-button>
    <cs-segment-button value="all">
      {{ periodLabel('all') }}
    </cs-segment-button>
  </cs-segment>
} @else {
  <cs-segment [(selection)]="timePeriod" (selectionChange)="handleTimePeriodChange($event)">
    <cs-segment-button value="week">
      {{ periodLabel('week') }}
    </cs-segment-button>
    <cs-segment-button value="month">
      {{ periodLabel('month') }}
    </cs-segment-button>
    <cs-segment-button value="quarter">
      {{ periodLabel('quarter') }}
    </cs-segment-button>
    <cs-segment-button value="year">
      {{ periodLabel('year') }}
    </cs-segment-button>
    <cs-segment-button value="all">
      {{ periodLabel('all') }}
    </cs-segment-button>
  </cs-segment>
}

<!-- Date Navigation -->
<div class="date-navigation">
  <cs-icon name="arrow-dropleft" (click)="handleDateNavigationPrev()"></cs-icon>
  <span class="date-range-text">{{ dateRangeText }}</span>
  <cs-icon name="arrow-dropright" (click)="handleDateNavigationNext()"
    [class.disabled]="isNextDisabled()"></cs-icon>
</div>
